import { ApiClient } from "../config/axiosConfig";
import {
  ICreatePosition,
  IDepartment,
  IDepartmentPosition,
  IPosition,
  IUpdatePosition,
  IUsersInDepartment,
} from "../models/Department";

export const departmentService = {
  getAllDepartments: async (): Promise<IDepartment[]> => {
    const res = await ApiClient.GET<IDepartment[]>("/departments");
    return res;
  },
  getDepartmentById: async (
    id: number
  ): Promise<IDepartmentPosition | undefined> => {
    const res = await ApiClient.GET<IDepartmentPosition>(`/departments/${id}`);
    return res;
  },
  getUserByDepartmentId: async (
    departmentCode: string
  ): Promise<IUsersInDepartment[]> => {
    const res = await ApiClient.GET<IUsersInDepartment[]>(
      `/departments/${departmentCode}/users`
    );
    return res;
  },
  updatePosition: async (data: IUpdatePosition): Promise<IPosition> => {
    const res = await ApiClient.PUT<IPosition>(`/positions/${data.id}`, data);
    return res;
  },
  deletePosition: async (id: number): Promise<void> => {
    const res = await ApiClient.DELETE(`/positions/${id}`);
    return res;
  },
  createPosition: async (data: ICreatePosition): Promise<IPosition> => {
    const res = await ApiClient.POST<IPosition>(`/positions`, data);
    return res;
  },
};
